/**
 * Regel-Grammatik der Segment-Engine.
 *
 * Der Unterschied zum Altsystem in einem Satz: dort gab es drei Regeltypen,
 * ausschliesslich mit UND verknuepft, ohne Zeitfenster und ohne Negation —
 * "hat Kampagne X in den letzten 14 Tagen NICHT geoeffnet" war schlicht nicht
 * ausdrueckbar. Hier ist jede Bedingung negierbar, jede Gruppe frei mit UND
 * oder ODER verknuepfbar, und Gruppen lassen sich beliebig verschachteln.
 */
export const EMAIL_EVENT_TYPES = [
    'sent',
    'delivered',
    'open',
    'click',
    'bounce_hard',
    'bounce_soft',
    'complaint',
    'unsubscribe',
    'reply',
    'failed',
];
/** Auf contacts abbildbare Felder. Die Zuordnung steht im Builder. */
export const ATTRIBUTE_FIELDS = [
    'email',
    'firstName',
    'lastName',
    'phone',
    'status',
    'source',
    'country',
    'city',
    'leadScore',
    'lifecycleStage',
    'consentStatus',
    'createdAt',
    'lastActivityAt',
];
export function isGroup(node) {
    return 'op' in node && 'children' in node;
}
//# sourceMappingURL=types.js.map